import { type LimitFragment } from '~/graphql/types';
import { LimitId } from '~/types/backendTypes';
import useLimitsMap from '../useLimitsMap';

/**
 * Used to retrieve limits
 * BE will communicate which limit to use to limit what feature
 * @param id LimitId generated in types.ts and managed on BE
 * @returns Limit
 */
const useLimit = (id: LimitId): LimitFragment => {
  const limitsMap = useLimitsMap();

  return (
    limitsMap[id] ?? { __typename: 'Limit_Soft', key: id, limit: Infinity }
  );
};

export default useLimit;
